import React, {
  // forwardRef,
  useState,
} from "react";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
// import { motion } from "framer-motion";
import { Backdrop, Box } from "@mui/material";
import { useThemeContext } from "../context/themeContext";
import { useTheme } from "@emotion/react";
import { getContentOptionsArray, getContentLabel } from "../utils/utils";

const userAction = {
  value: "profile",
  icon: <PersonIcon />,
  disabled: false,
  label: "Search profile",
};

export default function SearchButton({ onSelect, isFabAnimated }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { isTouchDevice } = useThemeContext();
  const theme = useTheme();
  const fabColour = theme.palette.primary.main;

  const actions = [
    ...getContentOptionsArray().map((option) => ({
      ...option,
      label: `Search ${getContentLabel({
        type: option.value,
        lowercase: true,
        plural: false,
      })}`,
    })),
    userAction,
  ];

  // const MotionFabWrapper = forwardRef(function MotionFabWrapper(props, ref) {
  //   return (
  //     <motion.div
  //       animate={isFabAnimated ? { scale: [1, 1.1, 1] } : { scale: 1 }}
  //       transition={{
  //         duration: 2,
  //         repeat: Infinity,
  //       }}
  //       ref={ref}
  //       {...props}
  //     />
  //   );
  // });

  return (
    <>
      <Backdrop
        open={open}
        sx={{
          zIndex: 1249,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(0, 0, 0, 0.7)"
              : "rgba(0, 0, 0, 0.7)",
        }}
      />
      <SpeedDial
        ariaLabel="Add content to library"
        sx={{
          position: "fixed",
          // Keeps the FAB's usual 30px gap from the viewport edge, only widening it if
          // an inset is larger than that — adding the inset to the 30px instead stacked
          // the two and lifted the button visibly up the screen in the installed PWA.
          // max() with a 0px inset is just 30px, so nothing changes elsewhere.
          bottom: "max(30px, var(--safe-bottom))",
          right: "max(30px, var(--safe-right))",
          zIndex: 1250,
        }}
        icon={
          <SpeedDialIcon
            icon={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "scale(1.3)",
                }}
              >
                <SearchIcon />
              </Box>
            }
            openIcon={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "scale(1.3)",
                }}
              >
                <CloseIcon />
              </Box>
            }
            className="add-button"
          />
        }
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        FabProps={{
          // component: MotionFabWrapper,
          sx: {
            width: 60,
            height: 60,
            bgcolor: fabColour,
            "&:hover": {
              bgcolor: fabColour,
            },
          },
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.label}
            icon={action.icon}
            tooltipTitle={action.label}
            disabled={action.disabled}
            tooltipOpen={!action.disabled && isTouchDevice}
            onClick={() => {
              handleClose();
              onSelect(action.value);
            }}
            FabProps={{
              sx: {
                bgcolor: fabColour,
                color: (theme) => theme.palette.primary.contrastText,
                "&:hover": {
                  bgcolor: fabColour,
                  color: (theme) => theme.palette.primary.contrastText,
                },
              },
            }}
          />
        ))}
      </SpeedDial>
    </>
  );
}
